import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type {
  DigitalGoodsQuery,
  DigitalGoodsVo,
  DigitalGoodsDetailUrlQuery,
  DigitalGoodsDetailQuery,
  DigitalGoodsDetailVo
} from './types.ts';

/**
 * 模板所有数据 包含（gamePoints、giftCards、subscriptions、software、videoGames）
 */
export const getVirtualProductSkuList = (params: DigitalGoodsQuery): AxiosPromise<DigitalGoodsVo> => {
  return request({
    url: '/product/urlMapping/digital/getVirtualProductSkuList',
    method: 'get',
    params
  });
};
/**
 * 根据路由获得skuUrl详情数据 包含（gamePoints、giftCards、subscriptions、software、videoGames）
 */
export const getVirtualProductSkuDetailByUrl = (params: DigitalGoodsDetailUrlQuery): AxiosPromise<DigitalGoodsDetailVo> => {
  return request({
    url: '/product/urlMapping/digital/getVirtualProductSkuDetailByUrl',
    method: 'get',
    params
  });
};

/**
 * 切换区域查详情 包含（gamePoints、giftCards、subscriptions、software、videoGames）
 */
export const getVirtualProductSkuDetail = (params: DigitalGoodsDetailQuery): AxiosPromise<DigitalGoodsDetailVo> => {
  return request({
    url: '/product/urlMapping/digital/getVirtualProductSkuDetail',
    method: 'get',
    params
  });
};

/**
 * 自定义集合页 落地页
 */
export const getVirtualProductSkuListByUrl = (params: DigitalGoodsQuery): AxiosPromise<DigitalGoodsVo> => {
  return request({
    url: '/product/urlMapping/digital/getVirtualProductSkuListByUrl',
    method: 'get',
    params
  });
};
